import { useState } from 'react'
import { TNotesProps } from './Notes.types'

export const useNotesLogic = (props: TNotesProps) => {
  const { onNotesChange } = props

  const [notes, setNotes] = useState<string[]>([''])

  const addNote = () => {
    setNotes((prev) => [...prev, ''])
  }

  const handleNoteChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setNotes((prev) => {
      const updatedNotes = [...prev]
      updatedNotes[Number(event.target.id)] = event.target.value
      onNotesChange?.(updatedNotes)
      return updatedNotes
    })
  }

  const removeNote = (index: number) => {
    setNotes((prev) => {
      const updatedNotes = prev.splice(index, 1)
      onNotesChange(updatedNotes)
      return updatedNotes
    })
  }

  return {
    notes,
    addNote,
    removeNote,
    handleNoteChange,
  }
}
